export default {
  nome: {
    value: '',
    maxlength: '70',
    required: false,
    state: null
  },
  document: {
    value: '',
    required: false,
    state: null
  },
  tipoPessoa: {
    value: '',
    options: [
      {value: 'PF', text: 'Pessoa Física'},
      {value: 'PJ', text: 'Pessoa Jurídica'}
    ],
    required: false,
    state: null
  },
  emailCorporativo: {
    value: '',
    maxlength: '70',
    required: false,
    state: null
  },
  dataNascimento: {
    value: '',
    mask: '##/##/####',
    required: false,
    state: null
  },
  siteUrl: {
    value: '',
    maxlength: '70',
    required: false,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configurations/account/components/add/person-form.js